// extracted by mini-css-extract-plugin
export default {"wrapper":"ActionButton_wrapper__aLw-R","text":"ActionButton_text__mZw5h"};